import { Redirect, Route, Switch, useLocation } from "wouter";
import fetcher from "../../utils/fetcher.ts";
import { useEffect, useState } from "react";

interface FecPanelProps {
  yearSelected: number | null;
}

const prefix = "comptaRest";

const getFec = async (year: number) => {
  const { blob, fileName } = await fetcher(
    `${prefix}/getFec`,
    { year },
    {},
    true,
  );
  const url = URL.createObjectURL(blob);
  // window.open(URL.createObjectURL(blob));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  link.parentNode!.removeChild(link);
};

const FecPanel = (props: FecPanelProps) => {
  const [isFetching, setIsFetching] = useState(false);
  const [, setLocation] = useLocation();
  useEffect(() => {
    setLocation(`/${props.yearSelected}`);
  }, [props.yearSelected]);

  const handleDownload = () => {
    if (isFetching) return;
    if (!props.yearSelected) return;
    setIsFetching(true);
    getFec(props.yearSelected).then(() => {
      // console.log("res from balanceDownload", res);
      //window.open(res);
      setIsFetching(false);
    });
  };
  return (
    <Switch>
      <Route path="/:year">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title mt-1">FEC</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <span className="align-middle">
                Télécharger FEC pour l'année {props.yearSelected}
              </span>
              <div className="col-2">
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={isFetching || !props.yearSelected}
                >
                  Télécharger
                </button>
              </div>
            </div>
          </div>
        </div>
      </Route>
      <Redirect to={`/${props.yearSelected}`} />
    </Switch>
  );
};

export default FecPanel;
